/* Oak & Velvet theme behaviour. No framework; progressive enhancement only:
   every form and link also works without this file. */
(() => {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const routes = (window.ov && window.ov.routes) || {};

  /* ── Cart ── */
  const drawer = $('[data-cart-drawer]');
  let lastFocus = null;

  function openDrawer() {
    if (!drawer || !window.ov.cartDrawer) return false;
    lastFocus = document.activeElement;
    drawer.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    const close = $('[data-cart-close]', drawer.querySelector('.drawer__panel'));
    if (close) close.focus();
    return true;
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
    if (lastFocus) lastFocus.focus();
  }

  async function refreshCart() {
    const res = await fetch(`${routes.root}?sections=cart-drawer-inner`);
    if (!res.ok) return;
    const data = await res.json();
    const html = new DOMParser().parseFromString(data['cart-drawer-inner'], 'text/html');
    const inner = $('[data-cart-drawer-inner]');
    const next = html.querySelector('.shopify-section') || html.body;
    if (inner) inner.innerHTML = next.innerHTML;
    const cart = await (await fetch(`${routes.cart}.js`)).json();
    $$('[data-cart-count]').forEach((el) => { el.textContent = cart.item_count; });
    document.dispatchEvent(new CustomEvent('ov:cart', { detail: cart }));
    return cart;
  }

  async function addToCart(form) {
    const button = form.querySelector('[type="submit"]');
    const status = form.querySelector('[data-cart-status]');
    if (button) { button.disabled = true; button.dataset.label = button.textContent; button.textContent = 'Toevoegen…'; }
    try {
      const res = await fetch(`${routes.cartAdd}.js`, { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
      const json = await res.json();
      if (!res.ok) throw new Error(json.description || json.message || 'Toevoegen lukte niet');
      await refreshCart();
      if (status) status.textContent = 'Toegevoegd aan je winkelwagen.';
      openDrawer();
    } catch (err) {
      if (status) status.textContent = err.message;
    } finally {
      if (button) { button.disabled = false; button.textContent = button.dataset.label; }
    }
  }

  async function changeLine(line, quantity) {
    await fetch(`${routes.cartChange}.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line: Number(line), quantity: Number(quantity) }) });
    await refreshCart();
    const focusable = drawer && $('[data-cart-close]', drawer);
    if (focusable) focusable.focus();
  }

  document.addEventListener('submit', (e) => {
    const form = e.target.closest('form[action$="/cart/add"]');
    if (!form || !window.ov.cartDrawer) return;
    e.preventDefault();
    addToCart(form);
  });

  document.addEventListener('click', (e) => {
    const open = e.target.closest('[data-cart-open]');
    if (open && openDrawer()) { e.preventDefault(); return; }
    if (e.target.closest('[data-cart-close]')) { e.preventDefault(); closeDrawer(); return; }
    const qty = e.target.closest('[data-cart-qty]');
    if (qty) { e.preventDefault(); changeLine(qty.dataset.line, qty.dataset.qty); return; }
    const closeDetails = e.target.closest('[data-close-details]');
    if (closeDetails) { const d = closeDetails.closest('details'); if (d) d.open = false; }
  });

  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    if (drawer && drawer.getAttribute('aria-hidden') === 'false') { closeDrawer(); return; }
    $$('details[data-mega][open], details[data-mobile-menu][open]').forEach((d) => { d.open = false; d.querySelector('summary').focus(); });
  });

  /* ── Mega menu: one open at a time, close on outside click ── */
  const megas = $$('details[data-mega]');
  megas.forEach((d) => d.addEventListener('toggle', () => { if (d.open) megas.forEach((o) => { if (o !== d) o.open = false; }); }));
  document.addEventListener('click', (e) => { if (!e.target.closest('details[data-mega]')) megas.forEach((d) => { d.open = false; }); });

  /* ── Tabs (role=tablist with [data-tab] buttons and [data-panel] panels) ── */
  $$('[data-tabs]').forEach((root) => {
    const tabs = $$('[data-tab]', root);
    const panels = $$('[data-panel]', root);
    const select = (i) => {
      tabs.forEach((t, j) => { t.setAttribute('aria-selected', String(i === j)); t.tabIndex = i === j ? 0 : -1; });
      panels.forEach((p, j) => { p.hidden = i !== j; });
    };
    tabs.forEach((t, i) => {
      t.addEventListener('click', () => select(i));
      t.addEventListener('keydown', (e) => {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
        const n = (i + (e.key === 'ArrowRight' ? 1 : tabs.length - 1)) % tabs.length;
        select(n); tabs[n].focus();
      });
    });
  });

  window.ovCart = { refresh: refreshCart, open: openDrawer, close: closeDrawer };
})();
